import React from 'react'
import styled from 'styled-components'

import { ChartPrefToggle } from '.'

const SettingsDiv = styled.div`
  margin-top: 30px;
`

const PreferenceText = styled.div`
    font-weight: 500;
    margin-bottom: 10px;
  }
`

export const PreferencesSection: React.FC = () => {
  return (
    <SettingsDiv>
      <h4 className="cb-roboto-slab-bold cb-margin-bottom-8">Preferences</h4>
      <div className="preferences">
        <PreferenceText>Default charts view for all users at my institution</PreferenceText>
        <ChartPrefToggle />
      </div>
    </SettingsDiv>
  )
}
